import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(errMsg(err));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-8">
      <div className="w-full max-w-sm">
        <div className="mb-8"><Logo /></div>
        <h2 className="nk-head text-2xl font-bold text-slate-900">Reset password</h2>
        {done ? (
          <p data-testid="forgot-confirm" className="text-sm text-slate-600 mt-4 bg-white border border-slate-200 rounded-md p-4">
            If that email is registered, a reset link has been sent. Please check your inbox.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-6">
            <p className="text-sm text-slate-500">Enter your email to receive a reset link.</p>
            <input
              data-testid="forgot-email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-slate-200 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="you@nakshatra.com"
            />
            {error && <div className="text-sm text-red-600">{error}</div>}
            <button type="submit" data-testid="forgot-submit"
              className="w-full rounded-md py-2.5 text-sm font-semibold text-white" style={{ background: "var(--nk-navy)" }}>
              Send reset link
            </button>
          </form>
        )}
        <div className="text-center mt-4">
          <Link to="/login" className="text-xs text-slate-500 hover:text-blue-600">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
